import React, { useContext, useState } from 'react'
import TodoContext from '../todoCtx/TdoCtx';
import "././stdForm.css"
import {getClass8Record, setClass8Record} from "../../services/class8Record.service"
import {getClass9Record, setClass9Record} from "../../services/class9Record.service"


const StdForm = (dragItem) => {

    const {dblListItems, setDblListItems, showDblList, setShowDblList, dblListItemsSepa, setDblListItemsSepa, compTodosMove1, showRecycleBin,setShowRecycleBin, showForm, setShowForm, students, setStudents, showStudents, setShowStudents, class8, showClass8, setShowClass8, storedId, formData, setFormData, studentName, setStudentName, studentClass, setShowStudentsSepa, setStudentsSepa,studentNameNew, setStudentNameNew, setClass8, setClass9} = useContext(TodoContext);

    

  

    // const class8data=["class 8", "class 9", "class 10"];
    // const class9data=["class 9", "class 8", "class 10"];


    const handleSave = () => {

        

        console.log("saved")
        console.log("studentName",studentName)

        const allStudents = [{ fullName : !!formData.fullName  ? formData.fullName : studentName, email : formData.email, number : formData.number, class : studentClass, id: storedId  }, ...students ];

        console.log("formData",formData);
        console.log("formDataname1", formData.fullName !== undefined ? formData.fullName : studentName);
        console.log("formDataname2", !!formData.fullName  ? formData.fullName : studentName);
       
        const newStudentSingle = [{ fullName :  !!formData.fullName  ? formData.fullName : studentName, email : formData.email, number : formData.number, class : studentClass, id: storedId  }];

        const newStudentSingleDb = { fullName : !!formData.fullName  ? formData.fullName : studentName, email : formData.email, number : formData.number,  class : studentClass, id: storedId  };

        
    

        setStudentNameNew(newStudentSingleDb.fullName);

        console.log("studentNameNew",studentNameNew);

        setStudentsSepa(newStudentSingle);

        setShowStudentsSepa(true);

        setShowStudents(false);

        setStudents(allStudents);



        if(studentClass === "8" ) 
        {
          setClass8(allStudents);
        }

        else if (studentClass === "9" ){
          setClass9(allStudents);
        }

        else{
          console.log("stdform else");
        }



        console.log("newStudentSingleDb",newStudentSingleDb);

        

        

        

        

        studentClass === "8" ? setClass8Record(newStudentSingleDb.id, newStudentSingleDb) : setClass9Record(newStudentSingleDb.id, newStudentSingleDb);

        // setStudentsSepa("");

        setShowForm(false);

        setFormData("");
       
      
    
    };

    const handleBack = () => {

        console.log("show all")

        setShowStudents(false);
        // setShowDblList(false);
        setShowForm(false);

        setFormData("");

        setShowClass8(showClass8=> !showClass8 );

        setStudentsSepa("");
       
      
    
    };

    const handleShowAll = () => {

        console.log("show all")

        setShowStudents(showStudents => !showStudents);
       
    };

    

    console.log(formData);

    const handleChange = (event) => {

        const {name,value,type,checked} = event.target;

        console.log("event target", event.target.value);
        console.log("name value", name, value);

        setFormData(prevFormData => {
            return {
                ...prevFormData,
                [name] : type==="checkbox" ? checked : value
            }
        } )

  
      };


      // useEffect(() => {

      //   setValue(props.value);
    
      // }, [props.value]);

  return (
    <div className='stdFormContainer'>


          <form >
        <div className="title">
          <i className="fas fa-pencil-alt"></i> 
          <h2>Add Student Details</h2>
        </div>
        <div className="info">
          <input className="fname" type="text" name="fullName" placeholder= "Full Name" onChange={handleChange} value={formData.fullName || studentName } maxLength="25" />

          <input type="email" name="email" placeholder="Email" onChange={handleChange} value={formData.email || ""} maxLength="40" />

          <input type="text" name="number" placeholder="Phone Number" onChange={handleChange} value={formData.number || ""} maxLength="15" />


          <select id="class" onChange={handleChange} name="class" >

            <option value={formData.class || ""} >Class {studentClass}</option>
            {/* <option value="class-8" >{studentClass}</option>
            <option value="class-9">{studentClass}</option> --------edit*/}  

    {/* {

        showClass8 ? class8data.map((opt,index) => <option key={index}>{opt}</option>) : class9data.map((opt,index) => <option key={index} >{opt}</option>)

    } */}

          </select>
        </div>

        <div className='btnWrapper'>

        <button className='btn-item' type="button" onClick={handleSave} >Save</button>
        <button className='btn-item' type="button" onClick={handleShowAll} >Show All</button>
        <button className='btn-item' type="button" onClick={handleBack} >BACK</button>

        </div>

      </form>
    
    
    </div>
  )
}

export default StdForm